import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BasicoComponent } from './basico/basico.component';
import { DiamanteComponent } from './diamante/diamante.component';
import { ProComponent } from './pro/pro.component';

@Component({
  selector: 'app-planes',
  templateUrl: './planes.component.html',
  styleUrls: ['./planes.component.scss'],
})
export class PlanesComponent implements OnInit {
  
  items = ['','',''];

  componentsPlans = {
    'diamante': DiamanteComponent,
    'pro':ProComponent,
    'basico':BasicoComponent
  }
  constructor(private modalController: ModalController) { }

  ngOnInit() {}

  changebg(item){
    
    this.items[item] = 'light';
  }
  clearBg(item){
    this.items[item] = ''    
  }

  async openModalPlan(plan:string){
      const modal = await this.modalController.create({
      component: this.componentsPlans[plan],
      cssClass:'modalPlan glassEffect'
      });
    
      await modal.present();
  

  }

}
